import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MediaListService {
  private updateSubject = new Subject<void>();

  get update$() {
    return this.updateSubject.asObservable();
  }

  triggerUpdate() {
    this.updateSubject.next();
  }
}
